/* eslint-disable react/jsx-curly-newline */
import CollapsibleContainer from '@components/common/CollapsibleContainer/CollapsibleContainer';
import {
  FILTER_CATEGORY_HOTEL_CLASS,
  FILTER_CATEGORY_STAR_CLASSIFICATION,
  FILTER_EVENT_NAMES,
} from '@constants/filterValues';
import {
  FilterOptionType,
  SrpFilterOptions,
  SrpFilters,
  StarClassificationFilter,
} from '@customTypes/srp-filters';
import React from 'react';

type Props = {
  srpFilters: SrpFilters | undefined;
  setFilters: (category: string, name: string, eventName: string) => void;
  filterOptions: SrpFilterOptions | undefined;
  isMobile: boolean;
  isMidScreen: boolean;
};

function StarRatingFilter({ srpFilters, setFilters, filterOptions, isMobile, isMidScreen }: Props) {
  return (
    <div>
      {filterOptions && filterOptions.star_classification && (
        <CollapsibleContainer
          title="Hotel Class"
          // eslint-disable-next-line no-nested-ternary
          height={`${isMobile ? '60px' : isMidScreen ? '190px' : '110px'}`}
        >
          <div className="flex flex-row gap-2.5 text-sm overflow-x-auto pb-4 overflow-hidden d:overflow-x-hidden mt-0.5 d:flex-wrap d:pb-0 d:mt-0">
            {filterOptions.star_classification.map((item: FilterOptionType) => (
              <React.Fragment key={item.id}>
                <button
                  className={`border border-solid px-5 py-2 rounded-l-full rounded-r-full whitespace-nowrap ${
                    srpFilters &&
                    srpFilters.star_classification[item.name as keyof StarClassificationFilter]
                      ? 'border-rp-primary bg-rp-primary-sky-blue text-rp-primary-dark'
                      : 'border-rp-gray-divider bg-none text-rp-primary-black'
                  }`}
                  type="button"
                  key={item.id}
                  onClick={() =>
                    setFilters(
                      FILTER_CATEGORY_STAR_CLASSIFICATION,
                      `${item.name}`,
                      FILTER_EVENT_NAMES[FILTER_CATEGORY_HOTEL_CLASS][item.name],
                    )
                  }
                >
                  {item.description}
                </button>
              </React.Fragment>
            ))}
          </div>
        </CollapsibleContainer>
      )}
    </div>
  );
}

export default StarRatingFilter;
